import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    boolean: "Oui/Non",
    text: "Texte",
    date: "Date",
    initial: "Bilan initial",
    checkUp: "Bilan de suivi",
    final: "Bilan final"
};

export type _I18nHealthCheck = typeof _fr;

const _en: _I18nHealthCheck = {
    boolean: "Yes/No",
    text: "Text",
    date: "Date",
    initial: "Initial check",
    checkUp: "Check-up",
    final: "Final check"
};

/**
 * Return i18n entries for TemplateHealthCheckItemFrom component in given language
 * @param lang Chosen language
 * @returns 
 */
export function I18nHealthCheck(lang?: string): _I18nHealthCheck {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}